// src/pages/produtos/produtos/ImpostosTab.js
import { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import Select from '../../../components/input/Select';
import { useBarra } from '../../../contexts/produtos/BarraContext';
import { IoIosAddCircle } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import NCMSearch from './NCMSearch';
import { useNCM } from '../../../contexts/produtos/NCMContext';
import { formatNumeric } from '../../../utils/numberUtils';

const ImpostosTab = ({ produto, setProduto, disableCampos }) => {
    const { barras, fetchbarras, addBarra, deleteBarra } = useBarra();  
    const { NCMs, ncmSel, fetchNcmByCodigo } = useNCM();
    const [eanTemp, setEanTemp] = useState('');
    const { showYesNo } = useYesNo();
    const [showBuscaNCM, setShowBuscaNCM] = useState(false);

    // Carrega as barras do produto ao montar ou mudar produto.id
    useEffect(() => {
        if (produto?.ehServico) {
            return;
        }

        if (produto?.id > 0) {
            fetchbarras(produto.id);  
            handleNCMExit();
            // console.log('Mudou Id');                                 
        } else {
            if (produto.ean) {
                setEanTemp(produto.ean);
            }             
        }
    }, [produto?.id, produto?.ehServico]);


    const handleAddBarra = async () => {
        if (!eanTemp.trim()) return;

        const novaBarra = {
            produtoId: produto.id,
            ean: eanTemp.trim()
        };

        await addBarra(novaBarra);
        setEanTemp('');
        await fetchbarras(produto.id);
    };

    const handleDeleteBarra = async (id) => {
      const resposta = await showYesNo("Deseja remover o código de barras?");
        if (resposta) {
            await deleteBarra(id);
        }
    }

    const handleBuscarNCM = () => {
      setShowBuscaNCM(true);
    }

    const handleSelectNCM = (nCM) => {        
        setProduto({ ...produto, ncm: nCM.codigo, ncmDescricao: nCM.descricao });
        setShowBuscaNCM(false);
    };

    const handleNCMExit = () => {
        if (produto.ncm) {
            if (NCMs.length>0) {
                const result = NCMs.find(n => n.codigo === produto.ncm);
                setProduto({ ...produto, ncm: result.codigo, ncmDescricao: result.descricao });
            } else {        
                //se não tiver baixado os ncms pega somente o selecionado    
                fetchNcmByCodigo(produto.ncm);
            }        
        }
    }

    const handleAliquotaBlur = (campo) => {
        const valor = produto[campo];
        setProduto({
            ...produto,
            [campo]: valor === null || valor === undefined || valor === ''
                ? null
                : formatNumeric(valor)
        });
    };

    const tributacaoIssqnOptions = [
        { value: '', label: 'Selecione' },
        { value: 1, label: '1 - Operação tributável' },
        { value: 2, label: '2 - Imunidade' },
        { value: 3, label: '3 - Exportação de serviço' },
        { value: 4, label: '4 - Não incidência' }
    ];

    const renderCamposServico = () => (
        <>
            <div className="input-group">
                <Input
                    label="Cód. Trib. Nacional"
                    value={produto.cTribNac || ''}
                    onChange={(e) => setProduto({ ...produto, cTribNac: e.target.value })}
                    disabled={disableCampos}
                    size={150}
                    maxLength={6}
                />
                <Input
                    label="Cód. Trib. Municipal"
                    value={produto.cTribMun || ''}
                    onChange={(e) => setProduto({ ...produto, cTribMun: e.target.value })}
                    disabled={disableCampos}
                    size={150}
                    maxLength={3}
                />
                <Input
                    label="NBS"
                    value={produto.nbs || ''}
                    onChange={(e) => setProduto({ ...produto, nbs: e.target.value })}
                    disabled={disableCampos}
                    size={150}
                    maxLength={12}
                />
                <Select
                    label="Tributação ISSQN"
                    value={produto.tribIssqn ?? ''}
                    options={tributacaoIssqnOptions}
                    onChange={(e) => setProduto({
                        ...produto,
                        tribIssqn: e.target.value ? Number(e.target.value) : null
                    })}
                    disabled={disableCampos}
                    size={210}
                />
            </div>

            <div className="input-group">
                <Input
                    label="Alíquota ISS (%)"
                    value={produto.aliquotaIss ?? ''}
                    onChange={(e) => setProduto({ ...produto, aliquotaIss: e.target.value })}
                    onBlur={() => handleAliquotaBlur('aliquotaIss')}
                    disabled={disableCampos}
                    size={110}
                />
                <Input
                    label="CST PIS/COFINS"
                    value={produto.cstPisCofinsServico || ''}
                    onChange={(e) => setProduto({
                        ...produto,
                        cstPisCofinsServico: e.target.value
                    })}
                    disabled={disableCampos}
                    size={120}
                    maxLength={2}
                />
                <Input
                    label="Alíquota PIS (%)"
                    value={produto.aliquotaPis ?? ''}
                    onChange={(e) => setProduto({ ...produto, aliquotaPis: e.target.value })}
                    onBlur={() => handleAliquotaBlur('aliquotaPis')}
                    disabled={disableCampos}
                    size={110}
                />
                <Input
                    label="Alíquota COFINS (%)"
                    value={produto.aliquotaCofins ?? ''}
                    onChange={(e) => setProduto({ ...produto, aliquotaCofins: e.target.value })}
                    onBlur={() => handleAliquotaBlur('aliquotaCofins')}
                    disabled={disableCampos}
                    size={130}
                />
            </div>

            <div className="input-group">
                <Input
                    label="CST IBS/CBS"
                    value={produto.cstIbsCbs || ''}
                    onChange={(e) => setProduto({ ...produto, cstIbsCbs: e.target.value })}
                    disabled={disableCampos}
                    size={110}
                    maxLength={3}
                />
                <Input
                    label="Class. Trib. IBS/CBS"
                    value={produto.cClassTribIbsCbs || ''}
                    onChange={(e) => setProduto({
                        ...produto,
                        cClassTribIbsCbs: e.target.value
                    })}
                    disabled={disableCampos}
                    size={160}
                    maxLength={6}
                />
                <Input
                    label="Indicador Operação IBS/CBS"
                    value={produto.cIndOpIbsCbs || ''}
                    onChange={(e) => setProduto({
                        ...produto,
                        cIndOpIbsCbs: e.target.value
                    })}
                    disabled={disableCampos}
                    size={190}
                    maxLength={6}
                />
            </div>
        </>
    );

    const renderCamposProduto = () => (
        <>
            <div className="input-group">
                <Input
                    label="NCM"
                    value={produto.ncm || ''}
                    onChange={(e) => setProduto({ ...produto, ncm: e.target.value })}
                    btnBuscar={handleBuscarNCM}
                    onBlur={handleNCMExit}
                    disabled={disableCampos}
                    btnBuscarDisabled={disableCampos}
                />
                <label style={{ color: 'black', backgroundColor: '#f0f0f0', 
                    paddingLeft:'5px', paddingRight:'5px', width: '460px', marginLeft: '0px', 
                    display:'flex', alignItems:'center' }}>
                    {produto.ncmDescricao || ncmSel.descricao}
                </label>
                
            </div>
            <div className="input-group">
                <Input
                    label="CFOP"
                    value={produto.cfop || ''}
                    onChange={(e) => setProduto({ ...produto, cfop: e.target.value })}
                    disabled={disableCampos}
                    size={80}
                    maxLength={4}
                />
                <Input
                    label="CSOSN"
                    value={produto.csosn || ''}
                    onChange={(e) => setProduto({ ...produto, csosn: e.target.value })}
                    disabled={disableCampos}
                    size={80}
                />
                <Input
                    label="CEST"
                    value={produto.cest || ''}
                    onChange={(e) => setProduto({ ...produto, cest: e.target.value })}
                    disabled={disableCampos}
                    size={80}
                />
                <Input
                    label="CST Pis/Cofins Ent."
                    value={produto.cstPisCofinsEnt || ''}
                    onChange={(e) => setProduto({ ...produto, cstPisCofinsEnt: e.target.value })}                    
                    disabled={disableCampos}
                    maxLength={2}
                />
                <Input
                    label="CST Pis/Cofins Sai."
                    value={produto.cstPisCofinsSai || ''}
                    onChange={(e) => setProduto({ ...produto, cstPisCofinsSai: e.target.value })}
                    disabled={disableCampos}
                    size={80}
                    maxLength={2}
                />

            </div>

            <div className="input-group align-items-end">
                <Input
                    label="Código de Barras"
                    value={eanTemp}
                    onChange={(e) => setEanTemp(e.target.value)}
                    disabled={disableCampos || !produto?.id}
                    size={300}
                />
                <button
                    className="btn btn-success ms-2"
                    type="button"
                    disabled={disableCampos || !produto?.id}
                    onClick={handleAddBarra}                    
                    title="Adicionar código de barras"
                >
                    <IoIosAddCircle size={22} />
                </button>
            </div>

            {/* Grid de Códigos de Barras */}
            <div className="table-responsive mt-3">
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>EAN</th>
                            <th style={{ width: 50 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {barras && barras.length > 0 ? (
                            barras.map(barra => (
                                <tr key={barra.id}>
                                    <td>{barra.id}</td>
                                    <td>{barra.ean}</td>
                                    <td className="text-center">
                                        <button
                                            className="btn btn-sm btn-danger"
                                            type='button'
                                            onClick={() => handleDeleteBarra(barra.id)}
                                            disabled={disableCampos}
                                            title="Excluir código"
                                        >
                                            <MdDelete size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center">Nenhum código de barras cadastrado.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <NCMSearch
                show={showBuscaNCM}
                onHide={() => setShowBuscaNCM(false)}
                onSelectNCM={handleSelectNCM}
            />
        </>
    );

    return (
        <div>
            {produto.ehServico ? renderCamposServico() : renderCamposProduto()}
        </div>
    );
};

export default ImpostosTab;
